import { render } from "./EventManagement.vue?vue&type=template&id=15e9ba08&scoped=true"
import script from "./EventManagement.vue?vue&type=script&lang=js"
export * from "./EventManagement.vue?vue&type=script&lang=js"

import "./EventManagement.vue?vue&type=style&index=0&id=15e9ba08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e9ba08"]])

export default __exports__